import { useEffect, useState } from "react";
import { S, useApp, set, kid } from "../store.ts";
import { Numi } from "../ui.tsx";
import { sayAloud } from "../question.ts";

/** Three easy moves, 10 seconds each: a 30-second stretch with Numi. */
const MOVES = ["Reach up high, like Numi flying.", "Roll your shoulders back, three times.", "Take three slow breaths: in through your nose, out through your mouth."];
const SECS = 30;

/** A short stretch break. Opened by pacing (when a child is working hard) or by the grown-up's "stretch break" setting. */
export function Break() {
  const s = useApp(); const why = s.breakOpen; const [left, setLeft] = useState(SECS);
  useEffect(() => {
    sayAloud(`${why === "pace" ? `You're working hard, ${kid()}.` : "Time for a quick stretch."} ${MOVES[0]}`);
    const t = setInterval(() => setLeft((l) => {
      const n = Math.max(0, l - 1);
      if (n > 0 && n % 10 === 0) sayAloud(MOVES[(SECS - n) / 10]);
      if (n === 0) sayAloud("All done. Ready when you are.");
      return n;
    }), 1000);
    return () => clearInterval(t);
  }, []);
  const done = () => { S.sinceBreak = 0; set({ breakOpen: null }); };
  const step = Math.min(MOVES.length - 1, Math.floor((SECS - left) / 10));
  return <div className="scrim breakscrim" role="dialog" aria-modal="true" aria-labelledby="brkT">
    <section className="sbreak">
      <Numi size={110} mood="fly" />
      <h2 id="brkT">{why === "pace" ? "Let's take a short break" : "Stretch break!"}</h2>
      <p className="note">{why === "pace" ? `You're working hard, ${kid()}. A 30-second stretch helps your brain.` : "A 30-second stretch, then back to maths."}</p>
      <ol className="moves">{MOVES.map((m, i) => <li key={i} className={i === step && left > 0 ? "now" : i < step || left === 0 ? "did" : ""}>{m}</li>)}</ol>
      <div className="sbreakbar" aria-label={`${left} seconds left`}><i style={{ width: `${((SECS - left) / SECS) * 100}%` }} /></div>
      <button className="btn yellow big" onClick={done}>{left ? "I'm ready" : "Back to maths"}</button>
    </section>
  </div>;
}
